module.exports = __webpack_public_path__ + "static/media/10.07118156.jpg";